import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Label } from 'reactstrap';
import { pluck } from 'underscore';
import { v4 as uuidV4 } from 'uuid';
import AssetAssociationsFacilities from './assetAssociationsFacilities';
import Icon from '../common/containers/icon';
import { changeItemWithConfirm, removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
import SinglePicker from '../common/controls/singlePicker';
const AssetAssociationsOrganizations = ({
  areaList,
  facList,
  onChange,
  organizations: _organizations = [],
  orgList,
  grpList
}) => {
  const handleAddNewFacility = index => {
    const facilities = JSON.parse(JSON.stringify(_organizations[index].facilities));
    const newFacility = {
      id: null,
      groups: []
    };
    facilities.push(newFacility);
    onChange(`organizations[${index}]/facilities`, facilities);
  };
  const handleChangeFacility = (index, name, value) => onChange(`organizations[${index}]/${name}`, value);
  const handleChangeOrganization = (index, value) => {
    const updatedOrganization = {
      id: value,
      facilities: []
    };
    onChange(`organizations[${index}]`, updatedOrganization);
  };
  const confirmOnChangeFields = ['facilities'];
  const handleChange = (index, value) => changeItemWithConfirm(_organizations[index], 'Organization (All associated facilities, groups and areas for this organization will be removed)', confirmOnChangeFields, handleChangeOrganization.bind(null, index, value));
  const handleRemoveOrganization = index => {
    const newOrganizations = JSON.parse(JSON.stringify(_organizations));
    newOrganizations.splice(index, 1);
    onChange('organizations', newOrganizations);
  };
  const confirmOnRemoveFields = ['id'];
  const handleRemove = index => removeItemWithConfirm(_organizations[index], 'Organization (and nested Facilities, Groups, Areas)', confirmOnRemoveFields, handleRemoveOrganization.bind(null, index));
  const usedOrganizations = pluck(_organizations, 'id');
  return /*#__PURE__*/React.createElement("div", null, _organizations.map((organization, index) => {
    const orgOptions = orgList.filter(org => org.id === organization.id || !usedOrganizations.includes(org.id));
    return /*#__PURE__*/React.createElement("div", {
      key: organization.id || uuidV4(),
      className: `t-aao-${index}`
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Associated Organization",
      onChange: value => handleChange(index, value),
      options: orgOptions,
      placeholder: "Select...",
      value: organization.id,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      className: "float-md-right form-control t-aag-remove-organization tqc-control",
      onClick: () => handleRemove(index)
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Organization"))), /*#__PURE__*/React.createElement(AssetAssociationsFacilities, {
      areaList: areaList,
      facilities: organization.facilities,
      facList: facList.filter(fac => fac.organizationID === organization.id),
      grpList: grpList,
      onChange: (name, value) => handleChangeFacility(index, name, value)
    }), /*#__PURE__*/React.createElement(Row, {
      style: {
        marginBottom: '15px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-input-custom-label"
    }, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: () => handleAddNewFacility(index),
      className: "float-md-right form-control t-aag-add-facility tqc-control",
      disabled: organization.id === null
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Facility"))), /*#__PURE__*/React.createElement("hr", null));
  }));
};
AssetAssociationsOrganizations.propTypes = {
  areaList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  facList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  grpList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  organizations: PropTypes.arrayOf(PropTypes.shape({
    facilities: PropTypes.arrayOf(PropTypes.shape({}))
  })),
  onChange: PropTypes.func.isRequired,
  orgList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default AssetAssociationsOrganizations;